import { h } from "preact";
import IconDotSpinner from "../../Icons/IconDotSpinner";

import styles from "./ItemsLoadingView.module.css";

export default function ItemsLoadingView() {
    return (
        <div class={styles.dropdownWithFilterItemsLoading}>
            <IconDotSpinner width={24}/>
        </div>
    );
}
